import { types } from "../types/types";

export const getEERR = (data) => ({
  type: types.eerr,
  payload: data,
});

export const importEERR = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getEERR(data));
    } catch (e) {
      console.error(e);
    }
  };
};

export const getDetailEERR = (data) => ({
  type: types.detailEerr,
  payload: data,
});

export const detailEERR = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getDetailEERR(data));
    } catch (e) {
      console.error(e);
    }
  };
};

export const getUpdateEERRNeeded = (data) => ({
  type: types.getUpdateEERRNeeded,
  payload: data,
});

export const importEERRUpdateNeeded = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getUpdateEERRNeeded(data));
    } catch (e) {
      console.error(e);
    }
  };
};